var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.stage)?_c('span',{},[_c('span',{staticClass:"dot-indicator ",class:{'mr-50': !_vm.onlyDot},style:(_vm.style)}),(!_vm.onlyDot)?_c('span',[_vm._v(_vm._s(_vm.stage.displayName))]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }